import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgHurricane(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 -4 16 24" {...props}>
      <path
        d="M11.762 3.634c-3.034.327-5.61.019-5.756-.69-.144-.707 2.198-1.546 5.232-1.873 3.034-.326 5.61-.018 5.756.69.144.708-2.198 1.546-5.232 1.873m6.812.238c.948-.528 1.485-1.132 1.42-1.736-.16-1.488-3.869-2.411-8.285-2.062-4.415.349-7.864 1.838-7.704 3.327.06.546.6 1.016 1.475 1.375 0 0 3.931 1.203 7.544.441 0 0-2.636 2.022-7.917.579 0 .014-.009.028-.008.043.026.577.421 1.104 1.076 1.546-.246.33-.386.687-.386 1.06 0 .7.493 1.339 1.291 1.86.475.247 1.967.88 4.92.88 0 0-1.33.843-3.762 1.15.202.277.497.532.867.755L12 16c1.49-.273 3.004-1.728 3.764-2.557 1.141-.454 1.889-1.156 1.889-1.953 0-.394-.196-.76-.514-1.092.79-.48 1.275-1.08 1.37-1.734-3.86 1.092-7.826-.248-7.826-.248 5.369.162 7.431-1.094 7.431-1.094.932-.561 1.476-1.243 1.443-1.965-.025-.55-.382-1.055-.983-1.485"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Hurricane')(SvgHurricane);
